import { ContentContainer } from "pages/common/styles";
import { Heading, PageContainer } from "./styles";
import {
  usePatientInterest,
  PatientInterestProvider,
} from "context/patient-interest";
import { InterestModal } from "components/interest-modal";
import { ResultsHeader } from "components/results-header";
import { KioskLongSurvey } from "../kiosk-long-survey";
import { RiskProfileProvider, useRiskProfile } from "context/risk-profile";

function PatientHubPage() {
  const riskProfile = useRiskProfile();
  const results = riskProfile?.kioskRiskResult;
  const { modalType } = usePatientInterest();

  const sessionId = localStorage.getItem("ciq-questionnaire.sessionId");

  if (!sessionId) {
    console.error("No session ID found in local storage");
    // TODO: Style error messages, though this is an edge case
    return <div>Error loading survey</div>;
  }

  return (
    <PageContainer data-id="PageContainer">
      <ContentContainer>
        <ResultsHeader />
        <Heading>Patient Hub</Heading>
        <KioskLongSurvey userId={sessionId} />
      </ContentContainer>
      {modalType && <InterestModal riskResults={results} isRemote={false} />}
    </PageContainer>
  );
}

export function PatientHub() {
  return (
    <PatientInterestProvider>
      <RiskProfileProvider>
        <PatientHubPage />
      </RiskProfileProvider>
    </PatientInterestProvider>
  );
}
